var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM17.707 8.29297C17.3165 7.90244 16.6835 7.90244 16.293 8.29297L10.125 14.4609L7.70703 12.043L7.63086 11.9746C7.23809 11.6543 6.65908 11.6769 6.29297 12.043C5.90244 12.4335 5.90244 13.0665 6.29297 13.457L9.41797 16.582C9.80849 16.9726 10.4415 16.9726 10.832 16.582L17.707 9.70703C18.0976 9.31651 18.0976 8.68349 17.707 8.29297Z",
    fill: "#55A63A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopied);
export default __webpack_public_path__ + "static/media/copied.88d89aca143cefb250ac8ba2f2c9c120.svg";
export { ForwardRef as ReactComponent };